// extracted by mini-css-extract-plugin
module.exports = {"abt_prj_wrp":"AboutProject_abt_prj_wrp__a6ors","imgwrp":"AboutProject_imgwrp__FE_iP"};